import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./UserLogsUIHelpers";

const UserLogsUIContext = createContext();

export function useUserLogsUIContext() {
  return useContext(UserLogsUIContext);
}

export const UserLogsUIConsumer = UserLogsUIContext.Consumer;

export function UserLogsUIProvider({ userLogsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openExceptionModal: userLogsUIEvents.openExceptionModal
  };

  return (
    <UserLogsUIContext.Provider value={value}>
      {children}
    </UserLogsUIContext.Provider>
  );
}